const galleryData = [
    {
        src: 'assets/images/small/img-1.jpg',
        thumb: 'assets/images/small/img-1.jpg',
        title: 'Man wearing black jacket',
        name: 'Justin Coke',
        id: 'webdesign',
        userimage: 'assets/images/users/avatar-3.jpg'
    },
    {
        src: 'assets/images/small/img-2.jpg',
        thumb: 'assets/images/small/img-2.jpg',
        title: 'Snow covered mountain',
        name: 'Toni Sanchez',
        text: 'danger',
        id: 'graphicdesign',
        userimage: 'assets/images/users/avatar-2.jpg'
    },
    {
        src: 'assets/images/small/img-3.jpg',
        thumb: 'assets/images/small/img-3.jpg',
        title: 'Woman sitting on rock',
        name: 'Maria Crowder',
        id: 'graphicdesign',
        userimage: 'assets/images/users/avatar-4.jpg'
    },
    {
        src: 'assets/images/small/img-4.jpg',
        thumb: 'assets/images/small/img-4.jpg',
        title: 'Smiling woman\'s face',
        name: 'Charles East',
        text: 'danger',
        id: 'webdesign',
        userimage: 'assets/images/users/avatar-5.jpg'
    },
    {
        src: 'assets/images/small/img-5.jpg',
        thumb: 'assets/images/small/img-5.jpg',
        title: 'Brown tabby cat sitting on concrete',
        name: 'David Buchanan',
        text: 'danger',
        id: 'illustrator',
        userimage: 'assets/images/users/avatar-6.jpg'
    },
    {
        src: 'assets/images/small/img-6.jpg',
        thumb: 'assets/images/small/img-6.jpg',
        title: 'Woman walking between brown',
        name: 'Lee Moore',
        id: 'webdesign',
        userimage: 'assets/images/users/avatar-7.jpg'
    },
    {
        src: 'assets/images/small/img-7.jpg',
        thumb: 'assets/images/small/img-7.jpg',
        title: 'Landscape photography of mountains',
        name: 'Julia Cruz',
        id: 'graphicdesign',
        userimage: 'assets/images/users/avatar-8.jpg'
    },
    {
        src: 'assets/images/small/img-1.jpg',
        thumb: 'assets/images/small/img-1.jpg',
        title: 'Man wearing black jacket',
        name: 'Craig Creek',
        id: 'webdesign',
        userimage: 'assets/images/users/avatar-9.jpg'
    },
    {
        src: 'assets/images/small/img-2.jpg',
        thumb: 'assets/images/small/img-2.jpg',
        title: 'Snow covered mountain',
        name: 'Gloria Pitt',
        id: 'illustrator',
        userimage: 'assets/images/users/avatar-10.jpg'
    },
    {
        src: 'assets/images/small/img-3.jpg',
        thumb: 'assets/images/small/img-3.jpg',
        title: 'Woman sitting on rock',
        name: 'Silas Seay',
        id: 'illustrator',
        userimage: 'assets/images/users/avatar-4.jpg'
    },
    {
        src: 'assets/images/small/img-4.jpg',
        thumb: 'assets/images/small/img-4.jpg',
        title: 'Smiling woman\'s face',
        name: 'Linda Ward',
        text: 'danger',
        id: 'photography',
        userimage: 'assets/images/users/avatar-5.jpg'
    },
    {
        src: 'assets/images/small/img-5.jpg',
        thumb: 'assets/images/small/img-5.jpg',
        title: 'Brown tabby cat sitting on concrete',
        name: 'Becky Eley',
        text: 'danger',
        id: 'photography',
        userimage: 'assets/images/users/avatar-6.jpg'
    }
];

export { galleryData };

